import { HeaderItem } from '@/types/headerItem';
import { TransactionColumn } from '@/types/transactionColumn';
import { TransactionRow } from '@/types/transactionRow';

const allHeaders: readonly HeaderItem<TransactionRow>[] = [
  {
    label: 'DATE',
    sortable: true,
    key: 'date',
  },
  {
    label: 'TYPE',
    sortable: true,
    key: 'type',
  },
  {
    label: 'METHOD',
    sortable: false,
    key: 'paymentType',
  },
  {
    label: 'AMOUNT',
    sortable: false,
    key: 'fromAmount',
  },
  {
    label: 'FROM',
    sortable: false,
    key: 'fromAccount',
  },
  {
    label: 'TO',
    sortable: false,
    key: 'toAccount',
  },
  {
    label: 'MARKUP',
    sortable: false,
    key: 'markup',
  },
  {
    label: 'EARNED',
    sortable: false,
    key: 'earned',
  },
  {
    label: 'STATUS',
    sortable: false,
    key: 'status',
  },
];

export const createHeaders = (
  tr: (original: string) => string,
  visibleColumns: readonly TransactionColumn[],
): readonly HeaderItem<TransactionRow>[] =>
  allHeaders
    .filter((header: HeaderItem<TransactionRow>): boolean =>
      visibleColumns.includes(header.key as TransactionColumn),
    )
    .map(
      (header: HeaderItem<TransactionRow>): HeaderItem<TransactionRow> => ({
        ...header,
        label: tr(header.label),
      }),
    );
